import { Button, ButtonSizes, ButtonVariants } from "@inno-ui/button";
import { ChevronRightIcon, Icon } from "@inno-ui/icons";
import { useTranslation } from "react-i18next";

import { MainContentLayout } from "../../../../layouts/desktop/main-content-layout/main-content-layout";
import { useAppointmentStore } from "../../../../store/appointment/appointment-store";
import { useGeneralStore } from "../../../../store/general/general-store";
import { formatCompleteTimezone } from "../../../../utils/helpers/date";
import { Calendar } from "../../../calendar";
import { TimeSlots } from "../../../time-slots/time-slots";
import styles from "./availability-selector.module.scss";

export function AvailabilitySelector() {
  const { currentTimezone, onNext } = useGeneralStore();
  const {
    appointmentData: { timeRange },
  } = useAppointmentStore();
  const { t } = useTranslation();

  return (
    <MainContentLayout>
      {/* right side */}
      <section className={styles.rightSideWrapper}>
        <h2>{t("select-date-and-time")}</h2>
        <div className={styles.calendarAndTimeSlotWrapper}>
          <div className={styles.calendarWrapper}>
            <Calendar />
            <div className={styles.timezone}>
              <Icon icon="GlobeFullIcon" color="var(--gray-400)" />
              {formatCompleteTimezone(currentTimezone)}
            </div>
          </div>
          <div className={styles.timeSlotWrapper}>
            <TimeSlots />
            {/* navigation buttons */}
            <div className={styles.navigationButton}>
              <Button
                label={t("next")}
                width="100%"
                variant={ButtonVariants.Dark}
                disabled={!timeRange.length}
                size={ButtonSizes.L}
                trailingIcon={ChevronRightIcon}
                type="button"
                onClick={onNext}
              />
            </div>
          </div>
        </div>
      </section>
    </MainContentLayout>
  );
}
